import { UserLoginOrRegistrationRequest, UserSocial } from '../../types';
import { sendUserToBackend } from './backendAuth';

export const exchangeCodeForUserInfo = async (code: string, state: string, redirect_uri: string): Promise<any> => {
  try {
    const requestBody = {
      "provider": "apple",
      "token_type": "AuthorizationCode",
      "code": code,
      "state": state,
      "redirect_uri": redirect_uri,
    }

    console.log('apple (requestBody)', requestBody, 'apple---------------------->', Math.random().toString(3));

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/social/exchange`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      throw new Error('Apple 토큰 교환 실패');
    }

    return await response.json();
  } catch (error) {
    console.error('Apple 토큰 교환 오류:', error);
    throw error;
  }
};

const REACT_APP_APPLE_CLIENT_ID=process.env.REACT_APP_APPLE_CLIENT_ID
const REACT_APP_APPLE_REDIRECT_URI=process.env.REACT_APP_APPLE_REDIRECT_URI

// Apple 로그인
export const appleLogin = async (navigate: any): Promise<UserSocial> => {
  return new Promise((resolve, reject) => {
    if (!REACT_APP_APPLE_CLIENT_ID || !REACT_APP_APPLE_REDIRECT_URI) {
      reject(new Error('Apple OAuth 설정이 올바르지 않습니다. 환경 변수를 확인해주세요.'));
      return;
    }

    let popup: WindowProxy | null = null;
    let messageHandled = false;
    
    try {
      const redirectUrl = new URL(REACT_APP_APPLE_REDIRECT_URI);

      if (redirectUrl.protocol !== 'https:') {
        console.warn('⚠️ 경고: Redirect URI가 HTTPS가 아닙니다. Apple OAuth는 HTTPS를 요구합니다.');
      }

      const url = new URL('https://appleid.apple.com/auth/authorize');
      
      const queryParams = new URLSearchParams({
        client_id: REACT_APP_APPLE_CLIENT_ID,
        response_type: 'code',
        response_mode: 'form_post',
        scope: 'name email',
        redirect_uri: redirectUrl.toString(),
        state: Math.random().toString(36).substring(2, 15),
      });
    
      url.search = queryParams.toString();

      const popupWidth = 500;
      const popupHeight = 600;
      const left = window.screenX + (window.outerWidth - popupWidth) / 2;
      const top = window.screenY + (window.outerHeight - popupHeight) / 2;
      
      popup = window.open(
        url.toString(),
        'apple-oauth',
        `width=${popupWidth},height=${popupHeight},left=${left},top=${top},scrollbars=yes,resizable=yes`
      );
      
      if (!popup) {
        reject(new Error('팝업이 차단되었습니다. 팝업 차단을 해제해주세요.'));
        return;
      }
      
    } catch (error) {
      console.error('❌ Redirect URI 파싱 실패:', error);
      reject(new Error('Redirect URI 형식이 올바르지 않습니다.'));
      return;
    }
    
    const handleMessage = async (event: MessageEvent) => {
      console.log('apple (event)', event, 'apple---------------------->', Math.random().toString(3));     
      if (messageHandled) {
        return;
      }
      
      if (event.data.type === 'OAUTH_SUCCESS') {
        messageHandled = true;
        const { code, id_token, provider, state, user } = event.data;

        try {
          let userInfo = null;

          try {
            userInfo = await exchangeCodeForUserInfo(code, state, REACT_APP_APPLE_REDIRECT_URI);
          } catch (error) {
            console.warn('백엔드 토큰 교환 실패, 팝업에서 받은 정보 사용:', error);
          }

          const socialUser: UserSocial = {
            id: userInfo?.user?.provider_id,
            name: userInfo?.user?.name || 'Apple 사용자',
            email: userInfo?.user?.email || '',
            provider: 'apple'
          };

          const userLoginOrRegistrationRequest: UserLoginOrRegistrationRequest = {
            ...socialUser,
          };
          
          const data = await sendUserToBackend(userLoginOrRegistrationRequest);
          if (data.success === false) {
            if ( data?.id !== undefined && data?.id !== null && data?.id !== '' ) {
              localStorage.setItem('kuid', data.id);

              if (!data?.agree_terms_of_service || !data?.agree_privacy_policy) {
                navigate('/join',{state:{social_provider:`apple`, user:data}});
                return;
              }
  
              if (!data.phone_number_verified) {
                const url = `/phone-verification?kuid=${data.id}`;
                navigate(url);
                return;
              }
            }

            reject(new Error(data.message || '로그인(또는 사용자등록)에 실패했습니다.'));
            return;
          } else {
            resolve(data);
          }
        } catch (error) {
          reject(error);
        } finally {
          window.removeEventListener('message', handleMessage);

          if (popup && !popup.closed) {
            popup.close();
          }
        }
      } else if (event.data.type === 'OAUTH_ERROR') {
        messageHandled = true;
        reject(new Error(event.data.error || 'Apple 로그인 실패'));
        window.removeEventListener('message', handleMessage);
        if (popup && !popup.closed) {
          popup.close();
        }
      }
    };
    
    window.addEventListener('message', handleMessage);
    
    const checkClosed = setInterval(() => {
      if (popup && popup.closed) {
        clearInterval(checkClosed);
        window.removeEventListener('message', handleMessage);
        reject(new Error('사용자가 로그인을 취소했습니다.'));
      }
    }, 1000);
  });
};
